import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import {
  Authorizations,
  AuthorizationType
} from 'src/app/shared/model/authorization.model';

@Component({
  standalone: true,
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class ConfirmModalComponent implements OnInit {
  typeText = '';
  listEmpty = false;
  comments = '';
  requestNumbers = [''];
  authorizationEnum = AuthorizationType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: string;
      requestType: string;
      list: Authorizations[];
    }
  ) {}

  ngOnInit(): void {
    this.data.type === 'REJECTED'
      ? (this.typeText = i18next.t('reject'))
      : (this.typeText = i18next.t('approve'));
    this.data.list === undefined
      ? (this.listEmpty = true)
      : (this.listEmpty = false);

    if (
      !this.listEmpty &&
      this.data.requestType === this.authorizationEnum.RED_PLATES
    ) {
      this.requestNumbers = this.data.list.map((item) => item.redPlateId!);
    } else if (
      !this.listEmpty &&
      this.data.requestType === this.authorizationEnum.TRANSFERS
    ) {
      this.requestNumbers = this.data.list.map((item) => item.id!);
    } else if (!this.listEmpty) {
      this.requestNumbers = this.data.list.map((item) => item.requestNumber!);
    }
  }

  changeComments(value: string) {
    this.comments = value;
  }

  closeModal() {
    this.dialogRef.close();
  }

  submitList() {
    this.dialogRef.close({
      data: this.comments,
      listRequests: this.requestNumbers
    });
  }
}
